"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var classnames_1 = __importDefault(require("classnames"));
var react_1 = __importDefault(require("react"));
var DropDownMultiSelectableGroup = function (props) {
    var children = props.children, name = props.name, classes = props.classes;
    var dropDownMultiSelectableItems = react_1.default.Children.toArray(children);
    return (react_1.default.createElement("div", { className: classnames_1.default('fds-dropdown-multiselectable-group', classes) },
        name && react_1.default.createElement("label", { className: "fds-dropdown-multiselectable-name" }, name),
        dropDownMultiSelectableItems && dropDownMultiSelectableItems.map(function (child, i) {
            return (react_1.default.createElement("div", { className: "fds-dropdown-multiselectable-item", key: i }, child));
        })));
};
DropDownMultiSelectableGroup.defaultProps = {
    children: []
};
exports.default = DropDownMultiSelectableGroup;
